import { render, staticRenderFns } from "./FtpCredentialDisplay.vue?vue&type=template&id=b2ff9944&scoped=true&"
import script from "./FtpCredentialDisplay.vue?vue&type=script&lang=js&"
export * from "./FtpCredentialDisplay.vue?vue&type=script&lang=js&"
import style0 from "./FtpCredentialDisplay.vue?vue&type=style&index=0&id=b2ff9944&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2ff9944",
  null
  
)

export default component.exports